module.exports = __webpack_public_path__ + "media/event_severe-winter.488d9ac0.mp3";